<template>
    <el-col :span="24" style="height:100%;">
        <el-card class="box-card" style="padding-right:50%;height:99%;overflow:auto;">
            <div slot="header" class="clearfix">
                <el-page-header @back="goBack" :content="pageTitle"></el-page-header>
            </div>
            <div class="layui-card-body">
                <el-form ref="form" :model="form" label-width="200px">
                    <!-- <el-form-item label="所属题库：">
                        <el-select v-model="form.storeId" placeholder="请选择">
                            <el-option
                            v-for="item in options"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item> -->
                    <el-form-item label="题型：">
                        <el-radio v-model="form.questType" label="1">单选题</el-radio>
                        <el-radio v-model="form.questType" label="2">多选题</el-radio>
                        <el-radio v-model="form.questType" label="3">判断题</el-radio>
                    </el-form-item>
                    <el-form-item label="题目：">
                        <el-input type="textarea" v-model="form.questWord"></el-input>
                    </el-form-item>
                    <!-- <div class="layui-form-item"> -->
                    <div label="" class="layui-form-text answer" id="answer" style="margin-left:200px;">
                        <label class="layui-form-label">选项：
                            <el-button @click="addQ" type="success" icon="el-icon-plus"></el-button>
                        </label>

                        <div class="questItem" id="opt_1" name="keyList" v-for="item in questOpt" :key="item.index">
                            <b :val="item.letter" style="font-weight: 700;margin-right:50px;" name="list.letter">{{item.letter}}</b>
                            <p class="text">是否是答案</p>
                            <p style="top: 3px;position: relative;">
                                <el-radio v-model="item.coverType" label="0">是</el-radio>
                                <el-radio v-model="item.coverType" label="1">否</el-radio>
                            </p>
                            <el-button :fatId="'opt_'+item.index" type="danger" size="mini" class="questDel" icon="el-icon-delete" @click="delOpt(item.index)"></el-button>
                            <el-input type="textarea"  v-model="item.opWord" rows="3" class="opWord" ></el-input>
                        </div>

                        <!-- <div class="questItem" id="opt_1" name="keyList">
                            <b val="A" style="font-weight: 700;margin-right:50px;" name="list.letter">A</b>
                            <p class="text">是否是答案</p>
                            <p>
                                <el-radio v-model="form.coverType1" label="0">是</el-radio>
                                <el-radio v-model="form.coverType1" label="1">否</el-radio>
                            </p>
                            <el-button fatId="opt_1" type="danger" class="layui-btn layui-btn-sm layui-btn-danger questDel" icon="el-icon-delete"></el-button>
                            <el-input type="textarea"  name="opWord" id="opt_word_1" class="layui-textarea opWord" ></el-input>
                        </div> -->
                    </div>
                    <!-- </el-form-item> -->
                    <!-- <div class="layui-form-item">
                        <div class="layui-form-text answer">
                            <label class="layui-form-label">选项：
                                <button ng-click="addQ()" type="button" class="layui-btn layui-btn-sm"><i class="layui-icon">&#xe654;</i></button>
                            </label>
                            <div class="layui-input-block questItem" id="opt_1" name="keyList">
                                <b val="A" style="font-weight: 700;margin-right:50px;" name="list.letter">A</b>
                                <p class="text">是否是答案</p>
                                <p>
                                    <input type="radio" name="list.coverType1" value="0" title="是">
                                    <input type="radio" name="list.coverType1" value="1" title="否" checked="">
                                </p>
                                <button type="button" fatId="opt_1" class="layui-btn layui-btn-sm layui-btn-danger questDel"><i class="layui-icon">&#xe640;</i></button>
                                <textarea placeholder="请输入内容" name="opWord" id="opt_word_1" class="layui-textarea opWord"></textarea>
                            </div>
                        </div>
                    </div> -->
                    <div class="layui-form-item" style="margin-top: 10px;">
                        <div class="layui-input-block">
                            <el-button class="layui-btn" type="primary" @click="submitForm">立即提交</el-button>
                            <!-- <el-button type="reset" class="layui-btn layui-btn-primary">重置</el-button> -->
                            <el-button type="button" class="layui-btn layui-btn-primary" @click="goBack()">返回</el-button>
                        </div>
                    </div>
                </el-form>
            </div>
        </el-card>
    </el-col>
</template>
<script>
import myHttp from "../../untils/port.js";
import util from '../../untils/util';
export default {
    data(){
        return{
            form:{
                id:'',
                storeId:'',
                questType:'1',
                questWord:'',
                answer:'',
                optionJson:''
            },
            options:[],
            groupId:'',
            zim:['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'],
            questOpt:[{
                index:1,
                letter:'A',
                coverType:'1',
                opWord:''
            }],
            pageTitle:'',
        }
    },
    mounted(){
        var params = this.$route.query;
        this.pageTitle ='题目添加'
        if(params.id!=0&&params.id!=''){
            this.form.id = params.id;
            this.pageTitle ='题目修改'
        }else{
            this.form.storeId = params.id1
        }
        this.groupId = util.session.get('groupId');
        if(util.session.get('roleId')=='3'){
            this.groupType = '3';
        }else if(this.$store.state.roleId=='4'){
            this.groupType = '1';
        }else if(this.$store.state.roleId=='5'){
            this.groupType = '2';
        }
        
        this.getStore();
        if(this.form.id!=''){
            this.getData();
        }
    },
    methods:{
        getStore(){
            var that = this;
            var that = this;
            myHttp.getAllStore({
                groupId:this.groupId,
                groupType:this.groupType,
                module:'enterprise',
        storeType:'1'
            }).then(function(resp){
                if(resp.data.code=="200"){
                    that.options = resp.data.data.storeList||[];
                }
            });
        },
        //根据id获取数据
        getData(){
            var that = this;
            myHttp.getExamById({
                id:this.form.id
            }).then(function(resp){
                if(resp.data.code=="200"){
                    var data = resp.data.data.question;
                    that.form.storeId = data.storeId;
                    that.form.questType = data.questType;
                    that.form.questWord = data.questWord;
                    var daAn = data.answer.split(",");
                    var list = data.options;
                    var newList = [];
                    for(var i=0;i<list.length;i++){
                        var index = that.zim.indexOf(list[i].opOption)+1;
                        var sel = daAn.indexOf(list[i].opOption)<0?'1':'0';
                        var sub = {
                            index:index,
                            letter:list[i].opOption,
                            opWord:list[i].opWord,
                            coverType:sel
                        }
                        newList.push(sub);
                    }
                    that.questOpt = newList;
                }
            });
        },
        //添加答案
        addQ(){
            if(this.questOpt.length>=6){
                this.$message.error('答案最多有6个');
                return;
            }
            var index = 1;
            var letter = 'A';
            var length = this.questOpt.length;
            if(length>0){
                var cur = this.questOpt[length-1].index;
                index = parseInt(cur) + 1;
                letter =this.zim[length];
            }
            var option = {
                index:index,
                letter:letter,
                coverType:'1',
                opWord:''
            }
            this.questOpt.push(option);
            console.log(this.questOpt);
        },
        //删除
        delOpt(val){
            var old = this.questOpt;
            var list = [];
            var setId = 1;
            for(var i=0;i<old.length;i++){
                if(val!=old[i].index){
                    old[i].index = setId;
                    old[i].letter = this.zim[parseInt(setId)-1];
                    list.push(old[i]);
                    setId++;
                }
            }
            this.questOpt = list;
        },
        //返回
        goBack(){
            this.$router.go(-1);
        },
        //提交
        submitForm(){
            var that = this;
            var list = this.questOpt;
            var isFlag = true;//判断是否只有一个答案
            var obj = [];
            for(var i=0;i<list.length;i++){
                var sub = { opOption: '', opWord: '' }
                sub.opOption = list[i].letter;
                sub.opWord = list[i].opWord;
                obj.push(sub);
                var isAns = list[i].coverType;
                if (isAns == '0' && this.form.answer == '') {
                    this.form.answer = sub.opOption;
                } else if (isAns == '0' && this.form.answer != '' && this.form.questionType == '1' || isAns == 0 && this.form.answer != '' && this.form.questionType == '3') {
                    isFlag = false;
                    this.$message.error('单选题或者判断题只能有一个答案');
                    break;
                } else if (isAns == 0) {
                    this.form.answer = this.form.answer + "," + sub.opOption;
                }
            }
            if (obj.answer == '') {
                this.$message.error('请选择答案');
                return;
            } else if (!isFlag) {
                return;
            } else{
                this.form.optionJson = JSON.stringify(obj);
                if(this.form.id==''){
                    myHttp.appExamSave(this.form).then(function (resp) {
                        if (resp.data.code == "200") {
                            that.$message.success('添加成功');
                            that.reload();
                        } else {
                            that.$message.error(resp.data.msg);
                            return;
                        }
                    }, function (error) {
                        that.$message.error("服务器繁忙，请稍候再试");
                    });
                }else{
                    myHttp.appExamForm(this.form).then(function (resp) {
                        if (resp.data.code == "200") {
                            that.$message.success('添加成功');
                            that.reload();
                        } else {
                            that.$message.error(resp.data.msg);
                            return;
                        }
                    }, function (error) {
                        that.$message.error("服务器繁忙，请稍候再试");
                    });
                }
            }
        },

        //
        reload(){
            this.form = {
                id:'',
                storeId:'',
                questType:'1',
                questWord:'',
                answer:'',
                optionJson:''
            }
        },
        
    }
}
</script>
<style scoped>
    p{
        padding:0;
        margin: 0;
    }
    .box-card{
        text-align: left;
    }
    .layui-form-label{
        /* float: left; */
        display: block;
        /* padding: 9px 15px; */
        font-weight: 400;
        line-height: 20px;
        text-align: right;
        /* position: absolute;
        left: 315px; */
        left: -235px;
        top: 10px;
        position: relative;
        height: 0;
        width: 200px;
    }
    .questItem{display: inline-block;}
    .questItem p{display: inline-block;}
    .questItem p.text{padding-top: 10px;position: relative;top: 4px;margin-right: 6px;}
    .questItem b{position: relative;top: 4px;font-size: 16px;}
    .layui-input-block{margin-left:200px;}
    .secondCon.layui-col-space15{
       margin: 0 10px;
    }
    .questDel{margin-left:10px;}
    .opWord{margin-top: 10px;margin-bottom: 15px;}
</style>